import React, { useState } from 'react'
import { useTranslation } from "react-i18next"
import { DialogTermsCond, DialogPoliticyPrivacy } from '../../pures'
import './simple-footer.pure.css'

/**
 * @return {*}
 * @status no delete 
 */
function SimpleFooterPure() {
  const { t, i18n } = useTranslation()
  const [modalTermsCond, setModalTermsCond] = useState(null)
  const [modalPolicityPrivacy, setModalPolicityPrivacy] = useState(null)

  const openModalTermsCond = (value) => {
    setModalTermsCond(value)
  }

  const openModalPolicityPrivacy = (value) => {
    setModalPolicityPrivacy(value)
  }

  return (
    <div className="general-container-simple-footer">
      <footer className="simple-footer-container">
        <p className="simple-footer-sa">{t('simpleFooter.aServiceFromA3CM')}</p>
        <a rel="noopener noreferrer" target='_blank' href={i18n.language === 'en' ? 'https://atix.digital/privacy-policy/' : 'https://atix.digital/aviso-de-privacidad/'} style={{ cursor: 'pointer', textDecoration: 'none' }} className="simple-footer-ad-privacity">{t('simpleFooter.noticeOfprivacy')}</a>
        <a rel="noopener noreferrer" target='_blank' href={i18n.language === 'en' ? 'https://atix.digital/terms-and-conditions/' : 'https://atix.digital/terminos-y-condiciones/'} style={{ cursor: 'pointer', textDecoration: 'none' }} className="simple-footer-ad-privacity">{t('simpleFooter.termsAndConditios')}</a>
      </footer>

      <DialogPoliticyPrivacy
        modalPolicityPrivacy={modalPolicityPrivacy}
        openModalPolicityPrivacy={openModalPolicityPrivacy}
      />

      <DialogTermsCond
        modalTermsCond={modalTermsCond}
        openModalTermsCond={openModalTermsCond}
      />
    </div>
  )
}


export { SimpleFooterPure as default }
